module.exports = __webpack_public_path__ + "images/file_icons_v2/jps-22c9801ec1e8f1a0357b7243f53fb25f.svg";